import { Grid } from '@mui/material';
import { parsePhoneNumber } from '@nx-smartmonkey/shared/helpers';
import { HSpacer, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';

import { Modal } from '../../../../components/Modal';
import InputText from '../../../../react-components/InputText';
import { Text } from '../../../../react-components/Text';
import { usePermissions } from '../../hooks/usePermissions';
import { useRetrieveVehicle } from '../../hooks/useRetrieveVehicle';
import { useUpdateVehicle } from '../../routes-list/hooks/useUpdateVehicle';

export const HomeSlidingMenuHeader = () => {
  const { data: vehicleDetails } = useRetrieveVehicle();
  const { isSoloDriver, hasSubscription } = usePermissions();
  const { isLoading: loadingVehicle, run: updateVehicle, success } = useUpdateVehicle();

  const vehicle = vehicleDetails?.vehicle;

  const [nameChangeDialog, setNameChangeDialog] = useState(false);
  const [name, setName] = useState(vehicle?.label);

  useEffect(() => {
    if (!loadingVehicle && success) {
      setNameChangeDialog(false);
    }
  }, [loadingVehicle, success]);

  if (!vehicle) return null;

  const parsedPhoneNumber = vehicle.phone ? parsePhoneNumber(vehicle.phone) : null;
  const vehiclePhone = parsedPhoneNumber
    ? `+${parsedPhoneNumber.countryCallingCode} ${parsedPhoneNumber.nationalNumber}`
    : ``;

  const updateVehicleLabel = () => {
    if (vehicle && !loadingVehicle) {
      updateVehicle({
        vehicle: vehicle,
        changes: {
          label: name,
        },
      });
    }
  };

  return (
    <>
      <Grid container wrap="nowrap" direction="column" position="relative">
        <Grid
          container
          direction="row"
          wrap="nowrap"
          alignItems="center"
          style={{
            background: RoutalPalette.white,
          }}
        >
          <Grid
            style={{
              justifyContent: `space-between`,
              width: `100%`,
              display: `flex`,
            }}
          >
            {/* Name, number and plan */}
            <Grid>
              {vehicle.label && (
                <Text
                  variant="h6"
                  style={{
                    color: RoutalPalette.secondary40,
                  }}
                  onClick={() => {
                    if (isSoloDriver) setNameChangeDialog(true);
                  }}
                >
                  {vehicle.label}
                </Text>
              )}

              <Grid style={{ display: `flex`, flexDirection: `row`, alignItems: `center` }}>
                {vehiclePhone && (
                  <Text
                    variant="small"
                    style={{
                      color: RoutalPalette.secondary00,
                    }}
                  >
                    {vehiclePhone}
                  </Text>
                )}
                {isSoloDriver && (
                  <>
                    {vehiclePhone && (
                      <>
                        <HSpacer small />
                        <div style={{ height: `4px`, width: `4px`, backgroundColor: RoutalPalette.secondary20n }} />
                        <HSpacer small />
                      </>
                    )}
                    <Text
                      variant="small"
                      style={{
                        color: RoutalPalette.secondary00,
                      }}
                      intlId={
                        hasSubscription
                          ? `drivers.preferences.subscription.plan_lite`
                          : `drivers.preferences.subscription.plan_free`
                      }
                    />
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Modal
        open={nameChangeDialog}
        title={{
          intlId: `drivers.preferences.edit_label_dialog.title`,
        }}
        isLoading={loadingVehicle}
        buttons={[
          {
            intlId: `accept`,
            disabled: (name ?? ``) === ``,
            onClick: () => {
              updateVehicleLabel();
            },
          },
          {
            intlId: `cancel`,
            onClick: () => {
              setNameChangeDialog(false);
            },

            variant: `text`,
            style: {
              border: `none`,
            },
          },
        ]}
        children={
          <>
            <VSpacer medium />
            <InputText
              placeholderIntlId="drivers.name.no_label"
              fieldValue={name || ``}
              onChange={(value) => setName(value)}
              variant="outlined"
              inputContainerStyles={{ width: `100%`, height: `40px` }}
              hoverBGColor={!isSoloDriver ? RoutalPalette.neutral00 : RoutalPalette.neutral02n}
              bGColor={!isSoloDriver ? RoutalPalette.neutral00 : RoutalPalette.neutral02n}
              inputStyles={{
                width: `100%`,
                borderColor: RoutalPalette.grey7,
                color: (name ?? ``) !== `` ? RoutalPalette.text : undefined,
              }}
            />
          </>
        }
      />
    </>
  );
};
